<template>
  <div class="admin_side">

    <div class="__menu">
      <el-menu 
        :default-active="activeIndex" 
        router>
        <el-menu-item index="/Manage/Home">
          <i class="menu_icon iconfont icon-tupian"></i>
          <span>Homepage Image</span>
        </el-menu-item>
        <el-menu-item index="/Manage/Data">
          <i class="menu_icon iconfont icon-shujuku"></i>
          <span>Data</span>
        </el-menu-item>
        <el-menu-item index="/Manage/Codes">
          <i class="menu_icon iconfont icon-wangluo"></i>
          <span>Source Codes</span>
        </el-menu-item>
        <el-menu-item index="/Manage/Programs">
          <i class="menu_icon iconfont icon-linghuokuozhan"></i>
          <span>Programs</span>
        </el-menu-item>
        <el-menu-item index="/Manage/Papers">
          <i class="menu_icon iconfont icon-lianjie"></i>
          <span>Published Papers</span>
        </el-menu-item>
        <el-menu-item index="/Manage/SecretKey">
          <i class="menu_icon iconfont icon-shenfenshibierenzheng"></i>
          <span>Secret Key</span>
        </el-menu-item>
      </el-menu>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Admin_Side',
  props: {
    activeIndex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  }
};
</script>

<style scoped>
</style>